<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { __color } from "@zyzgroup/core-web";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.greenCommon"]);

const color = ref();
const oppositeColor = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.greenCommon"].value;
  oppositeColor.value = __color.set(color.value).opposite(true).toString();
});
</script>

<template>
  <!-- 不设置 width="64" height="64" 自适应父元素 -->
  <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      d="M32 62C48.5685 62 62 48.5685 62 32C62 15.4315 48.5685 2 32 2C15.4315 2 2 15.4315 2 32C2 48.5685 15.4315 62 32 62Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M47.4148 21.6022C46.6345 20.7993 45.3768 20.7993 44.5965 21.6022L28.1278 38.0592L19.4035 29.0808C18.6232 28.2778 17.3655 28.2778 16.5852 29.0808C15.8049 29.8838 15.8049 31.1782 16.5852 31.9812L26.707 42.3978C27.4873 43.2007 28.745 43.2007 29.5253 42.3978L47.4148 24.5026C48.1951 23.6996 48.1951 22.4052 47.4148 21.6022Z"
      :fill="oppositeColor"
    />
  </svg>
</template>
